export const MISSED_CALL_BEHAVIOR_NOTHING = 1
export const MISSED_CALL_BEHAVIOR_VOICEMAIL = 2
export const MISSED_CALL_BEHAVIOR_FORWARD = 3
export const MISSED_CALL_BEHAVIOR_RETRY = 4
export const MISSED_CALL_BEHAVIOR_REROUTE = 5
